// favicon.service.ts
import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FaviconService {
  private renderer: Renderer2;
  private linkElement: HTMLLinkElement | null = null;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.initFaviconLink();
  }

  private initFaviconLink(): void {
    // Find existing favicon link element
    let link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");
    
    if (!link) {
      // Create new link element if none exists
      link = this.renderer.createElement('link');
      this.renderer.setAttribute(link, 'rel', 'icon');
      this.renderer.setAttribute(link, 'type', 'image/x-icon');
      this.renderer.appendChild(document.head, link);
    }
    
    this.linkElement = link;
  }

  // Change favicon by providing a new icon URL
  changeFavicon(iconUrl: string): void {
    if (this.linkElement) {
      this.renderer.setAttribute(this.linkElement, 'href', iconUrl);
    }
  }
}